import { render, staticRenderFns } from "./AnaliseProdutividade.vue?vue&type=template&id=0aa6ae93&scoped=true"
import script from "./AnaliseProdutividade.vue?vue&type=script&lang=js"
export * from "./AnaliseProdutividade.vue?vue&type=script&lang=js"
import style0 from "./AnaliseProdutividade.vue?vue&type=style&index=0&id=0aa6ae93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa6ae93",
  null
  
)

export default component.exports